// Deep-Link aus der globalen Suche: welches Modul welchen Eintrag öffnen soll.
// Die Suche setzt {module, id}, wechselt dann das Modul; das Zielmodul liest
// seinen Fokus (per Selector) und öffnet/scrollt zum Eintrag, dann clear().

import { create } from 'zustand';
import type { ModuleKey } from '../components/layout/AppLayout';

interface FocusState {
  module: ModuleKey | null;
  id: string | null;
  request: (module: ModuleKey, id: string) => void;
  clear: () => void;
}

export const useFocusStore = create<FocusState>((set) => ({
  module: null,
  id: null,
  request: (module, id) => { set({ module, id }); },
  clear: () => { set({ module: null, id: null }); },
}));
